<template>
	<div>
		<label class="text-sm sr-only" v-if="filterLabel" :for="filterName">{{ filterLabel }}</label>
		<el-select v-model="filterModel" size="small" class="w-40">
			<el-option v-for="option in filterOptions" :key="option.value"
			  :label="option.label"
			  :value="option.value">
			  	{{ option.label }}
			</el-option>
		</el-select>
	</div>
</template>

<script>
	export default {
		props: {
	  		filterName: {
	  			required: true,
	  			type: String
	  		},
	  		filterLabel: {
				type: String
			},
	  		formClass: {
	  			type: String
	  		},
	  		filterOptions: {
	  			required: true,
	  			type: Array
	  		},
	  		valueSelected: {
	  			required: true,
	  			type: String
	  		}
	  	},

	  	data() {
	  		return {
		  		name: this.filterName,
		  		filterModel: this.valueSelected
		  	}
	  	},

	  	watch: {
	  		filterModel() {
	  			this.$emit('filterchanged', { name: this.name, value: this.filterModel });
	  		}
	  	}
	}
</script>
